function clamp(n: number): number {
  return Math.max(0, Math.min(3, n));
}

// Split a round score into green/blue/purple/black segments for display.
// If per-axis points don't sum to the total (legacy sessions predating
// per-axis tracking), the shortfall is painted green so the bar still
// reflects the real score instead of going all-black.
export function getScoreSegments(
  score: number,
  makePoints: number,
  modelPoints: number,
  genPoints: number,
) {
  const make = clamp(makePoints);
  const model = clamp(modelPoints);
  const gen = clamp(genPoints);
  const unaccounted = Math.max(0, score - (make + model + gen));
  const missed = Math.max(0, 9 - score);
  return { make, model, gen, unaccounted, missed };
}
